import React, { Component } from 'react';
import $ from 'jquery'
import * as Common from '../CommonControlls/CommonJs';
import MainLayout from '../CommonControlls/MainLayout';
import Topmenu from '../CommonControlls/Topmenubar';
import { connect } from 'react-redux'
import Table from '../CommonControlls/TableRendrer'
import { Link } from 'react-router-dom';
import AlertModal from "../CommonControlls/AlertModal";
import jsPDF from "jspdf";

const mapStateToProps = (store) => {
    return store
}

const mapDispatchToProps = (dispatch) => {
    return {
        ShowAlert: (Settings) => { dispatch({ type: "UpdateAlert", payload: Settings }) },
        ShowLoader: (Isloading) => { dispatch({ type: "UpdateLoader", payload: Isloading }) },
    }
}

class Dispute_List extends Component {

    constructor(props) {
        super(props);
        this.state = {

            Save: true,
            Update: true,
            Delete: true,
            View: true,

            permissions: [],

            Tehsillist: [],
            Provincelist: [],
            Districtlist: [],

            // Table
            data: [],
            page: 1,
            sizePerPage: 15,
            TotalRecord: 0,
            loading: false,

            alertModalData: {
                title: "",
                message: "",
                First_Callback: () => { },
                Second_Callback: () => { },
                type: 1,
            },
        };
    }

    render() {

        const CellMenu = (cell, row) => {
            return (
                <div>
                    {this.state.permissions.includes('dispute-update') &&
                        <Link to={`/Dispute_Edit/${row.id}`}>
                            <button data-toggle="tooltip" title="Edit" class="btn TableRow_btn"><i
                                class="fa fa-pencil-square-o" aria-hidden="true"></i></button>
                        </Link>
                    }
                    <button data-toggle="tooltip" hidden={!this.state.permissions.includes('dispute-delete')} onClick={() => this.onDelete(row.id)} title="Delete" class="btn TableRow_btn"><i class="fa fa-trash-o" aria-hidden="true"></i></button>
                </div>
            )
        }

        const columns = [
            {
                dataField: 'id',
                text: 'ID',
                sort: true,
            },
            {
                dataField: 'provinceName',
                text: 'Province',

            },
            {
                dataField: 'districtName',
                text: 'District',
            },
            {
                dataField: 'tehsilName',
                text: 'Tehsil',
            },
           
            {
                dataField: 'patientSampleId',
                text: 'Sample Id',
            },
            {
                dataField: 'assignmentId',
                text: 'Job Id',
                sort: true,
            },

            {
                dataField: 'description',
                text: 'Description',
                headerStyle: (colum, colIndex) => {
                    return {width: '180px', fontSize: '13px'}
                },
            },

            
            {
                dataField: '',
                text: 'Actions',
                headerStyle: (colum, colIndex) => { return { width: '120px' } },
                formatter: (cell, row) => { return CellMenu(cell, row) },
                csvExport: false
            }
        ];

        return (

            <div>
                <AlertModal  {...this.state.alertModalData} />
                <MainLayout />
                <div id="right-panel" class="right-panel">
                    {/* <Topmenu /> */}
                    <Topmenu PageTitle="Dispute" isShowAddBtn={this.state.permissions.includes('dispute-add')} AddBtnLabel="Add Dispute" AddBtnLink="/Dispute_Add" />

                    <div class="content">

                        {/*<div class="PageHeader_Container">*/}
                        {/*    <h2 class="Pageheading">Ad</h2>*/}
                        {/*</div>*/}

                        <div class="card">
                            <div class="card-body">

                                {/* <div class="TableTop_Buttons">
                                    <span class="TableExport_button"><i class="fa fa-download" aria-hidden="true"></i> Export</span>
                                </div> */}

                                <Table
                                    keyField="id"
                                    data={this.state.data}
                                    page={this.state.page}
                                    sizePerPage={this.state.sizePerPage}
                                    totalSize={this.state.TotalRecord}
                                    onTableChange={this.handleTableChange}
                                    isPagination={true}
                                    columns={columns}
                                    changeSizePerPage={(size) => {
                                        setTimeout(() => {
                                            this.setState({
                                                exportLoading: true
                                            })
                                            this.ExportData(size)
                                        }, 100)
                                    }}
                                    loading={this.state.loading}
                                    exportPdf={this.ExportPdf}
                                    exportAllowed={this.state.permissions.includes('dispute-export')}
                                    RefreshTable={this.PopulateTable}
                                />

                            </div>
                        </div>

                    </div>
                </div>
            </div>

        )
    }
    componentWillMount() {
        if (this.props.UserAuthentication.AuthToken === "") {
            this.props.history.push("/Login")
        }
    }
    componentDidMount() {
        Common.AddClassToMenueLink("MenuParentLink_Dispute", false, "MenuParentLink_Security")

        this.GetPageConfigData(() => {
            this.PopulateTable()
        })
        Common.Ajax(this.props.UserAuthentication.AuthToken, "Get", false, Common.APILinks.SelectAll_RolesPermissions, {
            pageSize: 15,
            pageNumber: 1
        }, (resp) => {
            const modifiedPermissions = resp.data.filter(p => p.permissioN_GROUP === 'Settings' && p.permissioN_ALLOWED).map(d => d.permissioN_NAME)
            this.setState({permissions: modifiedPermissions})
        })
    }

    GetPageConfigData = (CallBack) => {
        this.props.ShowLoader({Isloading: true})
        var d1 = $.Deferred();
        var d2 = $.Deferred();
        var d3 = $.Deferred();
        this.SelectProvinces(() => {
            d1.resolve()
        })
        this.SelectDistricts(() => {
            d2.resolve()
        })
        this.SelectTehsil(() => {
            d3.resolve()
        })
        $.when(d1, d2, d3).done(() => {
            this.props.ShowLoader({Isloading: false})
            CallBack()
        });
    }
    handleTableChange = (type, { page, sizePerPage, sortField, sortOrder }) => {
        if (type === "sort") {
            let result = this.state.data
            // Handle column sort
            if (sortOrder === 'asc') {
                result = result.sort((a, b) => {
                    if (a[sortField] > b[sortField]) {
                        return 1;
                    } else if (b[sortField] > a[sortField]) {
                        return -1;
                    }
                    return 0;
                });
            } else {
                result = result.sort((a, b) => {
                    if (a[sortField] > b[sortField]) {
                        return -1;
                    } else if (b[sortField] > a[sortField]) {
                        return 1;
                    }
                    return 0;
                });
            }
            return
        }
        this.setState({
            page,
            sizePerPage
        }, () => {
            this.PopulateTable()
        })

    }
    SelectProvinces = (Callback) => {
        this.setState({ProvinceLoader: true})
        Common.Ajax(this.props.UserAuthentication.AuthToken, 'GET', false, Common.APILinks.SelectAll_Province, {}, (data) => {
            this.setState({
                ProvinceLoader: false,
                Provincelist: data.data.sort(Common.compare)
            })
            Callback()
        }, (error) => {
            this.setState({ProvinceLoader: false})
            this.props.ShowAlert({Type: 0, Msg: error})
            setTimeout(function () {
                $("#Alertmsgbtn").click()
            }, 50);
            Callback()
        })
    }
    SelectDistricts = (Callback) => {
        this.setState({ DistrictLoader: true })
        Common.Ajax(this.props.UserAuthentication.AuthToken, 'GET', false, Common.APILinks.SelectAll_District, {}, (data) => {
            this.setState({
                DistrictLoader: false,
                Districtlist: data.data.sort(Common.compare)
            })
            Callback()
        }, (error) => {
            this.setState({ DistrictLoader: false })
            this.props.ShowAlert({ Type: 0, Msg: error })
            setTimeout(function () { $("#Alertmsgbtn").click() }, 50);
            Callback()
        })
    }
    SelectTehsil = (Callback) => {
        this.setState({TehsilLoader: true})
        Common.Ajax(this.props.UserAuthentication.AuthToken, 'GET', false, Common.APILinks.SelectAll_Tehsil, {}, (data) => {
            this.setState({
                TehsilLoader: false,
                Tehsillist: data.data.sort(Common.compare)
            })
            Callback()
        }, (error) => {
            this.setState({TehsilLoader: false})
            this.props.ShowAlert({Type: 0, Msg: error})
            setTimeout(function () {
                $("#Alertmsgbtn").click()
            }, 50);
            Callback()
        })
    }

    ExportPdf = () => {
        const doc = new jsPDF()

        this.setState({ loading: true })
        Common.Ajax(this.props.UserAuthentication.AuthToken, "Get", false, Common.BaseUrlAPI+"/api/Dispute/SelectAll" ,{}, (resp) => {
                this.setState({ loading: false })
                if (resp.status) {
                    var ProcessedProvince= Common.ProcessDataInArray(this.state.Provincelist,"id")
                    var ProcessedDistrict= Common.ProcessDataInArray(this.state.Districtlist,"id")
                    var ProcessedTehsil= Common.ProcessDataInArray(this.state.Tehsillist,"id")
                    for (var i in resp.data)
                    {
                        resp.data[i].provinceName = ProcessedProvince[resp.data[i].provinceId]?.name
                        resp.data[i].districtName = ProcessedDistrict[resp.data[i].districtId]?.name
                        resp.data[i].tehsilName = ProcessedTehsil[resp.data[i].tehsilId]?.name
                    }
                    doc.autoTable({
                        theme: 'grid',
                        body: [
                            ...resp.data
                        ],
                        columns: [
                            {header: 'id', dataKey: 'id'},
                            {header: 'Province', dataKey: 'provinceName'},
                            {header: 'Tehsil', dataKey: 'tehsilName'},
                            {header: 'District', dataKey: 'districtName'},
                            {header: 'Sample Id', dataKey: 'patientSampleId'},
                            {header: 'Assignment Id', dataKey: 'assignmentId'},
                        ],
                    })

                    doc.save('name.pdf')

                }
            }, (error) => {
                $("#FormSearchBtn").prop('disabled', false);
                this.setState({ loading: false })
                this.props.ShowAlert({ Type: 0, Msg: "Something went wrong, please try again." })
                setTimeout(function () { $("#Alertmsgbtn").click() }, 50);
            }
        )
    }
    ExportData = (size) => {

        this.setState({ loading: true })
        Common.Ajax(this.props.UserAuthentication.AuthToken, "Get", false, Common.BaseUrlAPI+"/api/Dispute/SelectAll",{pageSize: size,
            pageNumber: 1}, (resp) => {
                this.setState({ loading: false })
                if (resp.status) {
                    var ProcessedProvince= Common.ProcessDataInArray(this.state.Provincelist,"id")
                    var ProcessedDistrict= Common.ProcessDataInArray(this.state.Districtlist,"id")
                    var ProcessedTehsil= Common.ProcessDataInArray(this.state.Tehsillist,"id")
                    for (var i in resp.data)
                    {
                        resp.data[i].provinceName = ProcessedProvince[resp.data[i].provinceId]?.name
                        resp.data[i].districtName = ProcessedDistrict[resp.data[i].districtId]?.name
                        resp.data[i].tehsilName = ProcessedTehsil[resp.data[i].tehsilId]?.name
                    }
                    this.setState({
                        data: resp.data,
                        TotalRecord: resp.data.totalRecord,
                        exportLoading: false
                    })
                    $(".react-bs-table-csv-btn").click()
                    this.PopulateTable()

                }
            }, (error) => {
                $("#FormSearchBtn").prop('disabled', false);
                this.setState({ loading: false })
                this.props.ShowAlert({ Type: 0, Msg: "Something went wrong, please try again." })
                setTimeout(function () { $("#Alertmsgbtn").click() }, 50);
            }
        )
    }
    PopulateTable = () => {
        this.setState({loading: true})

        var Parameters = {
            pageSize: this.state.sizePerPage,
            pageNumber: this.state.page,
            isPaginate: true
        }

        Common.Ajax(this.props.UserAuthentication.AuthToken, "Get", false, Common.BaseUrlAPI+"/api/Dispute/SelectAll", Parameters, (resp) => {
                this.setState({ loading: false })
                if (resp.status) {
                        var ProcessedProvince= Common.ProcessDataInArray(this.state.Provincelist,"id")
                        var ProcessedDistrict= Common.ProcessDataInArray(this.state.Districtlist,"id")
                        var ProcessedTehsil= Common.ProcessDataInArray(this.state.Tehsillist,"id")
                        for (var i in resp.data)
                        {
                            resp.data[i].provinceName = ProcessedProvince[resp.data[i].provinceId]?.name
                            resp.data[i].districtName = ProcessedDistrict[resp.data[i].districtId]?.name
                            resp.data[i].tehsilName = ProcessedTehsil[resp.data[i].tehsilId]?.name
                        }
                    this.setState({
                        data: resp.data,
                        TotalRecord: resp.totalRecord
                    })
                }
                else {
                    this.props.ShowAlert({ Type: 0, Msg: resp.message })
                    setTimeout(function () { $("#Alertmsgbtn").click() }, 50);
                }
            },
            (error) => {

                $("#FormSearchBtn").prop('disabled', false);
                this.setState({ loading: false })
                this.props.ShowAlert({ Type: 0, Msg: "Something went wrong, please try again." })
                setTimeout(function () { $("#Alertmsgbtn").click() }, 50);
            }
        )
    }

    onDelete = (id) => {
        this.setState({
            alertModalData: {
                title: "Delete Dispute?",
                message: "Are you sure you want to delete this record.",
                First_Callback: () => { $("#Generic-modal-CloseBtn").click(); this.DeleteRecord(id) },
                Second_Callback: () => { $("#Generic-modal-CloseBtn").click() },
                type: 1,
            }
        }, () => { $("#Show_ArletModal").click() })
    }
    DeleteRecord = (id) => {
        this.props.ShowLoader({Isloading: true})
        Common.Ajax(this.props.UserAuthentication.AuthToken, "Get", false, Common.BaseUrlAPI+"/api/Dispute/Delete", {
                id: id,
            },
            (Result) => {
                if (Result.status) {

                    this.props.ShowLoader({Isloading: false})
                    this.props.ShowAlert({Type: 1, Msg: "Deleted Successfully"})
                    this.PopulateTable()
                    setTimeout(function () {
                        $("#Alertmsgbtn").click()
                    }, 50);
                    $("#Form_CancelBtn").click()

                } else {
                    this.props.ShowLoader({Isloading: false})
                    this.props.ShowAlert({Type: 0, Msg: Result.message})
                    setTimeout(function () {
                        $("#Alertmsgbtn").click()
                    }, 50);
                }
            },
            (error) => {
                this.props.ShowLoader({Isloading: false})
                this.props.ShowAlert({Type: 0, Msg: "Something went wrong, please try again."})
                setTimeout(function () {
                    $("#Alertmsgbtn").click()
                }, 50);
            })
    }

}

export default connect(mapStateToProps, mapDispatchToProps)(Dispute_List);
